(function(){
  // ====== Config ======
  // Claves posibles para localizar la referencia (por si cambias el nombre)
  const WARRANTY_PROPERTY_KEYS = [
    'Cobertura para variante',         // recomendado
    'cobertura para variante',
    'coverage_for_variant',
    'coverage_variant_id'
  ];

  // ====== Utilidades ======
  function toId(val){
    if (val == null) return null;
    const s = String(val).trim();
    if (/^\d+$/.test(s)) return Number(s);
    const m = s.match(/(\d+)$/);
    return m ? Number(m[1]) : null; // extrae dígitos finales (sirve para GID)
  }

  async function getCart(){
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }});
    if (!res.ok) throw new Error('No se pudo leer /cart.js');
    return res.json();
  }

  function findCheckoutButton(){
    return document.querySelector('button[name="checkout"], [name="checkout"][type="submit"], .cart__checkout-button');
  }

  function findShopifyPaymentButtonContainer(){
    // Contenedor de Shop Pay / Apple Pay / Google Pay
    return document.querySelector('.shopify-payment-button');
  }

  // Analiza validez: ¿toda garantía tiene su producto principal?
  function analyze(cart){
    const mainQtyByVariant = new Map();   // variant_id -> qty
    const warrantyLines = [];             // { item, targetId }

    for (const item of cart.items){
      const props = item.properties || {};
      // Busca la propiedad de cobertura (case-insensitive)
      let cov = null;
      for (const k of Object.keys(props)){
        if (WARRANTY_PROPERTY_KEYS.some(p => p.toLowerCase() === String(k).toLowerCase())){
          cov = props[k];
          break;
        }
      }

      if (cov != null && String(cov).trim() !== ''){
        warrantyLines.push({ item, targetId: toId(cov) });
      } else {
        // Lo tratamos como producto principal
        const k = String(item.variant_id);
        mainQtyByVariant.set(k, (mainQtyByVariant.get(k) || 0) + item.quantity);
      }
    }

    const missing = [];
    const usedByVariant = new Map();

    for (const { item, targetId } of warrantyLines){
      const k = String(targetId);
      const available = mainQtyByVariant.get(k) || 0;
      const used = usedByVariant.get(k) || 0;
      const remaining = available - used;

      if (!targetId || remaining < item.quantity){
        missing.push({
          warrantyTitle: item.product_title + (item.variant_title ? ' – ' + item.variant_title : ''),
          warrantyQty: item.quantity,
          targetId: targetId || null,
          available
        });
      } else {
        usedByVariant.set(k, used + item.quantity);
      }
    }

    return {
      valid: missing.length === 0,
      missing
    };
  }

  // UI: muestra/oculta error y bloquea checkout
  function renderError(missing){
    const container =
      document.querySelector('.cart__footer, .cart-footer, [data-cart-footer]') ||
      document.querySelector('form[action="/cart"]') ||
      document.querySelector('#CartDrawer, .drawer, body');

    if (!container) return;

    // Limpia anterior
    const old = document.getElementById('warranty-cart-error');
    if (old) old.remove();

    if (!missing || !missing.length) return;

    const div = document.createElement('div');
    div.id = 'warranty-cart-error';
    div.setAttribute('role', 'alert');
    div.style.background = '#fff3cd';
    div.style.border = '1px solid #ffeeba';
    div.style.padding = '12px';
    div.style.margin = '8px 0';
    div.style.fontSize = '0.95rem';

    const lines = missing.map(m => {
      const tgt = m.targetId ? ` (ID variante destino: ${m.targetId})` : '';
      const det = m.available ? ` — Cantidad de producto disponible: ${m.available}` : '';
      return `La garantía “${m.warrantyTitle}” no tiene su producto asociado${tgt} o supera su cantidad${det}.`;
    }).join('<br>');

    div.innerHTML = `⚠️ <strong>No puedes continuar al pago.</strong><br>${lines}`;
    container.prepend(div);
  }

  function setCheckoutLocked(locked){
    const checkoutBtn = findCheckoutButton();
    const spb = findShopifyPaymentButtonContainer();

    document.documentElement.classList.toggle('warranty-cart-invalid', locked);

    if (checkoutBtn){
      checkoutBtn.disabled = locked;
      checkoutBtn.setAttribute('aria-disabled', String(locked));
      checkoutBtn.style.opacity = locked ? '0.5' : '';
      checkoutBtn.style.pointerEvents = locked ? 'none' : '';
      // En algunos temas, el botón es <a>. Entonces no tiene disabled:
      if (checkoutBtn.tagName === 'A' && locked){
        checkoutBtn.addEventListener('click', blockLink, { once: true });
      }
    }
    if (spb){
      // Oculta Shop Pay / Apple Pay / Google Pay si hay error
      spb.style.display = locked ? 'none' : '';
    }
  }

  function blockLink(e){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }

  async function validate({silent=false} = {}){
    try{
      const cart = await getCart();
      const { valid, missing } = analyze(cart);
      setCheckoutLocked(!valid);
      if (!valid && !silent) renderError(missing);
      else {
        const old = document.getElementById('warranty-cart-error');
        if (old) old.remove();
      }
      return valid;
    } catch(err){
      console.error('[Warranty] Error al validar carrito', err);
      // En caso de error de red, no bloquees checkout para no frenar ventas
      setCheckoutLocked(false);
      return true;
    }
  }

  // Intercepta el submit de carrito solo cuando es "checkout"
  function bindCartFormGuard(){
    const cartForm = document.querySelector('form[action="/cart"], form.cart, #cart form');
    if (!cartForm || cartForm.dataset.warrantyGuardBound === '1') return;

    cartForm.dataset.warrantyGuardBound = '1';
    cartForm.addEventListener('submit', async function(e){
      // Intento de pasar a checkout
      const submitter = e.submitter || document.activeElement;
      const isCheckout = submitter &&
        (submitter.name === 'checkout' || submitter.getAttribute('name') === 'checkout');

      if (!isCheckout) return; // otras acciones (actualizar carrito, etc.)

      const ok = await validate({ silent: false });
      if (!ok){
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    });

    // También intercepta clicks directos en el botón de checkout (por si no hay submitter)
    const btn = findCheckoutButton();
    if (btn && btn.dataset.warrantyClickBound !== '1'){
      btn.dataset.warrantyClickBound = '1';
      btn.addEventListener('click', async function(ev){
        const ok = await validate({ silent: false });
        if (!ok){
          ev.preventDefault();
          ev.stopPropagation();
          ev.stopImmediatePropagation();
        }
      });
    }
  }

  // Revalida cuando cambian cantidades / se actualiza el DOM del carrito
  function observeCartChanges(){
    const root = document.querySelector('[data-cart-items], .cart-items, #CartDrawer, .ajax-cart__content, .cart__items, form[action="/cart"]');
    if (!root || !('MutationObserver' in window)) return;

    const mo = new MutationObserver(() => validate({ silent: true }));
    mo.observe(root, { childList: true, subtree: true });
  }

  // Init
  document.addEventListener('DOMContentLoaded', () => {
    bindCartFormGuard();
    observeCartChanges();
    validate({ silent: true }); // evalúa al cargar
  });

  // Soporta recargas parciales del editor/sections (Dawn y derivados)
  document.addEventListener('shopify:section:load', () => {
    bindCartFormGuard();
    observeCartChanges();
    validate({ silent: true });
  });
})();
